import { render, staticRenderFns } from "./BrokerListAdmin.vue?vue&type=template&id=71793589&"
import script from "./BrokerListAdmin.vue?vue&type=script&lang=ts&"
export * from "./BrokerListAdmin.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports